export enum DialogType {
	NONE = "none",
	CONFIRMATION = "confirmation",
	REASSIGNMENT = "reassignment",
	CALL_OFF = "call_off",
	REMOVE_CALL_OFF = "remove_call_off",
}

export enum StatusTransitionType {
	SIMPLE = "simple",
	COMPLEX = "complex",
	FORBIDDEN = "forbidden",
}

export interface StatusTransition {
	fromStatus: string;
	toStatus: string;
	type: StatusTransitionType;
	dialogType: DialogType;
	title?: string;
	message?: string;
	requiresInput?: boolean;
	menuLabel?: string;
}

export interface ConfirmationDialogProps {
	open: boolean;
	title: string;
	message: string;
	onConfirm: () => void;
	onCancel: () => void;
	loading: boolean;
  doNotRemindMeCheckBoxKey?: string;
}

export interface ReassignmentData {
	qualifiedJobs: QualifiedJob[];
	currentAssignment: {
		job: string;
		workcenter: string;
	};
	shiftDetails: {
		shiftPatternName: string;
		date: string;
		startTime: string;
		endTime: string;
	};
	workerFullName: string;
	createsCoverage: boolean;
	overtimeShift?: OvertimeShift;
}

export interface QualifiedJob {
	id: string;
	name: string;
	workcenter: string;
	workersGap: number;
	workersSurplus: number;
	criticality: "Low" | "Medium" | "High";
}

export interface OvertimeShift {
	workcenter: string;
	jobRole: string;
	startTime: string;
	endTime: string;
	workersRequired: number;
	totalHours: number;
}

export interface CallOffData {
	shiftDetails: {
		shiftPatternName: string;
		date: string;
		startTime: string;
		endTime: string;
	};
	currentAssignment: {
		job: string;
		workcenter: string;
	};
	workerFullName: string;
	absenceType: "Full Shift" | "Arrive Late" | "Leave Early";
	duration?: number; // for partial absences
	timeOffTypes: TimeOffType[];
	reason: string;
	createsCoverage: boolean;
	overtimeShift?: OvertimeShift;
}

export interface TimeOffType {
	id: string;
	name: string;
	remainingBalance: number;
}

export interface RemoveCallOffData {
	workerFullName: string;
	previousStatus: string;
	previousStatusName: string;
	coverageShift?: CoverageShift;
}

export interface CoverageShift {
	id: string;
	startDateTime: string;
	endDateTime: string;
	workcenter: string;
	primaryJob: string;
}

export interface TransitionDialogState {
	dialogType: DialogType;
	isOpen: boolean;
	data: any;
	loading: boolean;
	error: string | null;
}
